/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExchangeProgramPartnerSchool
 */
export interface ExchangeProgramPartnerSchool {
    /**
     * 
     * @type {number}
     * @memberof ExchangeProgramPartnerSchool
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramPartnerSchool
     */
    regionName: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramPartnerSchool
     */
    countryName: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramPartnerSchool
     */
    nameJa: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramPartnerSchool
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramPartnerSchool
     */
    partnerType: ExchangeProgramPartnerSchoolPartnerTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ExchangeProgramPartnerSchoolPartnerTypeEnum {
    Undergraduate = 'Undergraduate',
    Academic = 'Academic'
}

export function ExchangeProgramPartnerSchoolFromJSON(json: any): ExchangeProgramPartnerSchool {
    return ExchangeProgramPartnerSchoolFromJSONTyped(json, false);
}

export function ExchangeProgramPartnerSchoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeProgramPartnerSchool {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'regionName': json['regionName'],
        'countryName': json['countryName'],
        'nameJa': json['nameJa'],
        'name': json['name'],
        'partnerType': json['partnerType'],
    };
}

export function ExchangeProgramPartnerSchoolToJSON(value?: ExchangeProgramPartnerSchool | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'regionName': value.regionName,
        'countryName': value.countryName,
        'nameJa': value.nameJa,
        'name': value.name,
        'partnerType': value.partnerType,
    };
}


